module.exports = __webpack_public_path__ + "assets/img/header-photo-01.86e9aa5e.png";